import {
  SET_SCROLL_POSITION,
  RESET_SCROLL_POSITION
} from 'bento-ordering/base/actions/actionTypes';

/**
 * save scroll position for a specific entity
 */
export const setScrollPosition = (entity, yPos) => {
  return {
    type: SET_SCROLL_POSITION,
    payload: { entity, position: yPos }
  };
};

export const resetScrollPosition = entity => {
  return {
    type: RESET_SCROLL_POSITION,
    payload: { entity }
  };
};
